import type { Enemy } from "../entities/Enemy.ts";

/** Interaction types an enemy can be immune to (data-driven via enemies.json).
 *  Extend this union as new immunity kinds are added to the data. */
export type ImmunityType = "chain";

/**
 * Single source of truth for data-driven enemy immunities (D-088 / F-17).
 *
 * An enemy may be immune to a specific interaction (e.g. Cipher Breaker is
 * immune to water-tower chain bounces). Every interaction that can be
 * immunity-gated must consult this predicate instead of re-inlining an
 * `immunities.includes(...)` check — same discipline as isStealthHidden().
 *
 * Note: immunity is NOT untargetability. A chain-immune enemy can still be
 * targeted and hit directly; only the chain *bounce* skips it.
 */
export function isImmuneTo(enemy: Enemy, immunity: ImmunityType): boolean {
  return enemy.immunities.includes(immunity);
}
